import { render, staticRenderFns } from "./SkupTemaBase.vue?vue&type=template&id=4e7a8978&scoped=true&"
import script from "./SkupTemaBase.vue?vue&type=script&lang=js&"
export * from "./SkupTemaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7a8978",
  null
  
)

export default component.exports